










































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CardData } from '@/types/cardData';

@Component({
  name: 'NewCard',
  components: {},
})

export default class NewCard extends Vue {
  @Prop({ type: Array, required: true }) public taskCards!: CardData[];

  public dialog: boolean = false;
  public dateField: boolean = false;
  public taskName: string = '';
  public taskDescription: string = '';
  public taskPriority: boolean = true;
  public selection: number = 0;
  public currentDate: string = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
  public date: string = this.currentDate;

  public createCard(title: string, value: string, date: string, isMain: boolean): CardData {
    return {
      title: title,
      value: value,
      date: date,
      is_main: isMain,
    };
  }

  public resetForm(): void {
    this.taskName = '';
    this.taskDescription = '';
    this.date = this.currentDate;
    this.selection = 0;
  }

  public closeModal(): any {
    this.dialog = false;
    this.resetForm();
  }

  public saveData(): any {
    this.dialog = false;
    const newCard: CardData = this.createCard(this.taskName, this.taskDescription, this.date, this.taskPriority);
    this.taskCards.push(newCard);
    this.resetForm();
  }
}

